import { useSyncExternalStore } from "react";
const createPreference = (key) => {
    const listeners = new Set();
    let fallback = false;
    let memoryOnly = false;
    const notify = () => listeners.forEach((listener) => listener());
    const onStorage = (event) => {
        if (event.storageArea === window.localStorage &&
            (event.key === key || event.key === null)) {
            notify();
        }
    };
    return {
        subscribe(listener) {
            if (listeners.size === 0)
                window.addEventListener("storage", onStorage);
            listeners.add(listener);
            return () => {
                listeners.delete(listener);
                if (listeners.size === 0)
                    window.removeEventListener("storage", onStorage);
            };
        },
        getSnapshot() {
            if (memoryOnly)
                return fallback;
            try {
                fallback = localStorage.getItem(key) === "true";
            }
            catch {
                memoryOnly = true;
            }
            return fallback;
        },
        set(value) {
            fallback = value;
            try {
                localStorage.setItem(key, String(value));
                memoryOnly = false;
            }
            catch {
                memoryOnly = true;
            }
            notify();
        },
    };
};
const preferences = {
    combined: createPreference("memdb:club-team-status:show-all-steps"),
    club: createPreference("club-web:club-status:show-all-steps"),
    registration: createPreference("club-web:registration-status:show-all-steps"),
};
export const useShowAllStatusSteps = (type) => {
    const preference = preferences[type];
    const showAll = useSyncExternalStore(preference.subscribe, preference.getSnapshot, () => false);
    return [showAll, preference.set];
};
//# sourceMappingURL=useShowAllStatusSteps.js.map